import React from "react";
import { MenuOutlined } from "@ant-design/icons";

const Header = (props) => {
  // console.log("HEADER props", props);
  const userId = localStorage.getItem("user_id");
  const companyName = localStorage.getItem("company_name");

  return (
    <div className="header-wrapper">
      <MenuOutlined style={{color: '#aaa', marginRight: 12, width: 18}} />
      <div>
        <div className="header-text">
          {`${process.env.REACT_APP_BOT_NAME || "Bodhi Fin Bot"} (${userId || '-'})`}
        </div>
        <div className="header-subtext">
          Traind on{" "}
          <b style={{ fontWeight: 800, fontFamily: "monospace" }}>
            {companyName}
          </b>
        </div>
      </div>
    </div>
  );
};

export default Header;
